<script lang="ts">
  import { isMobile, reverseChildNodesForArabicLang, roundToAtMaxNDigits } from '../../../../common/util';
  import Icon from '../../components/Icon.svelte';

  export let rating;
  export let totalReviews;
  export let ratedFor: string;

  const isResponsive = isMobile();
  $: roundedRating = roundToAtMaxNDigits(rating, 10);
</script>

<section class="rating-mini-container">
  <section class="rating-numbers">
    <Icon glyph="rating-filled" size={12} type="svg" />
    <span use:reverseChildNodesForArabicLang><span>{roundedRating}</span> <span>({totalReviews})</span></span>
  </section>
  {#if !isResponsive}
    <section class="rated-for">
      {ratedFor}
    </section>
  {/if}
</section>

<style lang="scss">
  @import '../../styles/colors.new.scss';

  .rating-mini-container {
    .rating-numbers,
    .rated-for {
      font-size: 14px;
      line-height: 16px;
    }
    .rating-numbers {
      display: flex;
      align-items: center;
      font-weight: 500;
      gap: 2px;
      color: $neutral-dark-01;
    }
    .rated-for {
      font-weight: 400;
      padding-top: 4px;
      border-top: 1px solid $secondary-gray-02;
      margin-top: 4px;
      color: $neutral-dark-03;
    }
  }
</style>
